import React, { FormEvent, ReactElement } from 'react';
import {
  Button,
  DatePicker,
  FormGroup,
  Heading,
  Label,
  LoaderButton,
} from 'idsk-react-components';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import CheckDataTable from '../component/CheckDataTable';
import scrollToTop from '../../../function/scrollToTop';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  loading: boolean;
  getFieldErrorMessage: (fieldName: string) => string;
  clearStatus: () => void;
  isUpdate?: boolean;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const DatesStep2 = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  loading,
  getFieldErrorMessage,
  clearStatus,
  isUpdate = false,
  onChange,
}: Props): ReactElement => (
  <div className="prispevok-vestnika-step-pages">
    <Heading className="page-title" size="xl">
      { isUpdate ? 'Úprava dátumu zverejnenia a účinnosti' : 'Vyplňte dátum zverejnenia a účinnosti'}
    </Heading>
    <FormGroup error={!!getFieldErrorMessage('datumZverejnenia')}>
      <Label htmlFor="datumZverejnenia">Dátum zverejnenia</Label>
      <DatePicker
        id="datumZverejnenia"
        name="datumZverejnenia"
        width="one-third"
        showIcon
        value={prispevokVestnika.datumZverejnenia}
        onChange={date => onUpdateField('datumZverejnenia', date)}
        error={getFieldErrorMessage('datumZverejnenia')}
      />
    </FormGroup>
    <FormGroup error={!!getFieldErrorMessage('datumUcinnosti')}>
      <Label htmlFor="datumZverejnenia">
        Dátum účinnosti <span className="idsk-hint optional-message">(nepovinný údaj)</span>
      </Label>
      <DatePicker
        id="datumUcinnosti"
        name="datumUcinnosti"
        width="one-third"
        showIcon
        value={prispevokVestnika.datumUcinnosti}
        onChange={date => onUpdateField('datumUcinnosti', date)}
        error={getFieldErrorMessage('datumUcinnosti')}
      />
    </FormGroup>
    <LoaderButton
      loading={loading}
      type="submit"
      size="large"
      onClick={(e) => onSubmit(e, PrispevokVestnikaStepEnum.RELATED_DATA_3)}
    >Pokračovať
    </LoaderButton>
    <Button
      className="prispevok-vestnika-step-pages__back-button"
      type="button"
      buttonStyle="third"
      size="large"
      disabled={loading}
      onClick={() => {
        clearStatus();
        onUpdateField('activeStep', PrispevokVestnikaStepEnum.BASIC_DATA_1);
        scrollToTop();
      }}
    >
      Späť
    </Button>
    <Heading size="m">Vaše odpovede</Heading>
    <CheckDataTable
      onChange={onChange}
      prispevokVestnika={prispevokVestnika}
      isUpdate={isUpdate}
    />
  </div>
);

export default DatesStep2;
